/** Live voice and spoken feedback: pointer states, voice commands, engines,
 *  acknowledgements and the errors the voice toast shows. */
export default {
  liveStarting: "Live voice starting",
  liveListening: "Live voice listening",
  liveSending: "Live voice sending",
  denkerSpeaking: "Denker speaking",

  commandSleep: "Go to sleep",
  commandNewChat: "New chat",
  commandUseCli: "Use {cli}",
  commandVoiceOn: "Voice on",
  commandVoiceOff: "Voice off",
  voiceOnToast: "Denker reads its replies aloud again",
  voiceOffToast:
    "Denker answers in text only. Say or type “voice on” to hear it again",

  engineDenker: "Denker voices",
  engineDenkerHint: "Natural — brief pause first",
  engineWindows: "Windows voices",
  engineWindowsHint: "Instant — more synthetic",

  acknowledgeGotIt: "Got it.",
  acknowledgeOkay: "Okay.",
  acknowledgeOnIt: "On it.",
  previewLine: "Hi, I am Denker. This is my voice.",

  acknowledgeSure: "Sure.",

  cliSwitchBusy: "A CLI switch is already in progress.",
  cliUnavailable: "{cli} is not available. Connect it in settings first.",
  cliSwitchNoProject: "Open a project with Denker before switching CLI.",
  cliSwitchChatChanged:
    "The active chat changed. Repeat the CLI command in the current chat.",
  cliSwitchAgentMissing: "The selected agent could not be loaded. Try again.",

  errorDetectionNotStarted: "Microphone speech detection did not start.",
  errorDetectionFailed: "Local speech detection failed. Restart listening.",
  errorMicNoRestart: "Microphone could not restart.",
  errorDetectionNoAudio: "Microphone speech detection stopped receiving audio.",
  errorPlaybackFailed: "Agent voice playback failed.",
  errorCaptureFailedCode: "Continuous speech capture failed ({code}).",
  errorCaptureFailed: "Continuous speech capture failed.",
  errorPlaybackOverlap: "Too many overlapping agent voice playbacks.",
  errorPlaybackNoCompletion: "Agent voice playback did not report completion.",
  errorSpeechReset: "Could not reset speech after playback.",
  errorTranscriptionTimeout:
    "Speech transcription timed out. Please restart listening and try again.",
  errorWakeListen: "Could not start listening after the wake word.",
} as const;
